import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import WidgetShell from './WidgetShell';
import type { StatusBreakdownRow } from './types';

export interface StatusBreakdownProps {
  title: string;
  rows: StatusBreakdownRow[];
  isLoading?: boolean;
  embedded?: boolean;
  viewAllPath?: string;
  emptyMessage?: string;
}

const StatusBreakdown: React.FC<StatusBreakdownProps> = ({
  title,
  rows,
  isLoading,
  embedded,
  viewAllPath,
  emptyMessage = 'No data',
}) => {
  const { colors } = useTheme();
  const all = rows.reduce((sum, row) => sum + row.value, 0);

  return (
    <WidgetShell
      title={title}
      embedded={embedded}
      viewAllPath={viewAllPath}
      isLoading={isLoading}
      empty={!isLoading && all === 0}
      emptyMessage={emptyMessage}
    >
      <div className="space-y-2">
        {rows.map((row) => {
          const pct = all > 0 ? (row.value / all) * 100 : 0;
          return (
            <div key={row.key}>
              <div className="mb-1 flex items-center justify-between text-xs">
                <span className={colors.textMuted}>{row.label}</span>
                <span className={colors.text}>{row.value}</span>
              </div>
              <div className="h-2 w-full rounded bg-slate-200 dark:bg-slate-700">
                <div className={`h-2 rounded ${row.color}`} style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </WidgetShell>
  );
};

export default StatusBreakdown;
